import { trackDigitalEvent } from '@sparknz/tracking';

import {
  DeviceOfferDetail,
  EventInfo,
  PaymentOption,
} from 'journey/productDetails/typings';
import { constructAnalyticsProduct } from 'journey/productDetails/utils/constructAnalyticsProduct';

export function trackAccountSelectorActionLayer({
  eventInfo,
  device,
  isBusiness,
  paymentOption,
}: {
  eventInfo: EventInfo;
  device: DeviceOfferDetail;
  isBusiness: boolean;
  paymentOption: PaymentOption;
}) {
  trackDigitalEvent({
    event: eventInfo.eventAction,
    w3cddl: {
      event: [
        {
          eventInfo,
          attributes: {
            isSuccess: true,
          },
        },
      ],
      product: [
        constructAnalyticsProduct({ device, isBusiness, paymentOption }),
      ],
    },
  });
}
